import axios from "axios";
import { Toast } from "vant";
import $router from "@/router";
import authService from "@/utils/authService";
const service = axios.create({
  // // 生产环境走线上 API，开发环境可由 .env 文件配置为 /api 走本地代理
  // baseURL: process.env.VUE_APP_BASE_URL || "https://52huahuo.cn",
    // 生产环境走线上 API，开发环境优先使用相对路径 '/'，由 devServer proxy 转发到本地后端
    baseURL:
      process.env.NODE_ENV === "development"
        ? "/"
        : process.env.VUE_APP_BASE_URL || "https://52huahuo.cn",
  timeout: 60000,
});

// let reqList = [];

let loading;
function startLoading() {
  loading = Toast.loading({
    message: "加载中...",
    forbidClick: true,
    duration: 0,
  });
}

function endLoading() {
  loading.clear();
}

/* request拦截器 */
service.interceptors.request.use(
  async (config) => {
    try {
      // 根据平台使用不同的token获取方式
      if (authService.isAutoLoginEnabled()) {
        // 原生App：使用新的认证服务获取token
        const token = authService.getAccessToken();
        if (token) {
          config.headers.Authorization = "Bearer " + token;
          // console.log('[Network] Authorization token added (Native)');
        } else {
          // console.log('[Network] No access token available (Native)');
        }
      } else {
        // 浏览器/H5：使用传统的sessionStorage方式
        const userInfoStr = sessionStorage.getItem("userInfoXpz");
        if (userInfoStr) {
          const userInfo = JSON.parse(userInfoStr);
          const token = userInfo?.access_token;
          if (token) {
            config.headers.Authorization = "Bearer " + token;
            // console.log('[Network] Authorization token added (H5)');
          } else {
            // console.warn('[Network] No access_token in userInfo (H5)');
          }
        } else {
          // console.warn('[Network] No userInfoXpz in sessionStorage (H5)');
        }
      }
    } catch (e) {
      console.error('[Network] Error getting token:', e);
    }
    //自定义
    // config.headers.Authorization= 'eyJhbGciOiJSUzI1NiJ9.eyJzdWIiOiIxNTQ0MTAzIiwidXNlcklkIjoiYThhNDZjNDktMDY1YS00ZDFjLWFlM2YtZjY1MTY0OTdhYmViIiwidXNlck5hbWUiOiLlvKDluKbnj60iLCJ4eGRtIjoiMTU0NCIsInR5cGUiOiIzIiwibW9iaWxlIjoiMTg2NjgwMDUwNjkiLCJ1c2VyY29kZSI6IjEwMyIsImV4cGlyZSI6MTY1Nzk1ODI5NjU4MX0.NsybFCMCcZoICkLB_GBpeA3xyCfN3tBKPvdGTqhgflFJuHSkFb5Ivs_ovCLYHvf4MsTD3FiDkrAoFU2HVfXK8adR00XodZ1HP96KdCPZM43H4cUaei0aTbnfCAQlcx09QUVbmVVb7LfUqRebm4IOHBn59SXdq_Krur7kaPtB3v0';
    // let cancel;
    // 设置cancelToken对象
    config.cancelToken = new axios.CancelToken(function () {});
    
    // 修改这里：增加对params中noLoading的判断
    if (!config.noLoading && (!config.params || !config.params.noLoading)) {
      startLoading();
    }
    
    // 添加网络请求日志，方便在 Android Studio Logcat 中查看
    // 注意：只用于日志，不影响实际请求（axios 会自动处理 params）
    // try {
      // let queryString = '';
      // if (config.params) {
      //   // 安全地构建查询字符串，避免 URLSearchParams 兼容性问题
      //   const params = config.params;
      //   const pairs = Object.keys(params).map(key => {
      //     const value = params[key];
      //     if (value !== null && value !== undefined) {
      //       return encodeURIComponent(key) + '=' + encodeURIComponent(value);
      //     }
      //     return null;
      //   }).filter(Boolean);
      //   queryString = pairs.length > 0 ? '?' + pairs.join('&') : '';
      // }
      // const fullUrl = config.baseURL + config.url + queryString;
      
      // console.log('[Network] ========== Request Start ==========');
      // console.log('[Network] Method:', config.method?.toUpperCase());
      // console.log('[Network] URL:', fullUrl);
      // console.log('[Network] BaseURL:', config.baseURL);
      // console.log('[Network] Path:', config.url);
      // console.log('[Network] Params:', config.params ? JSON.stringify(config.params) : 'none');
      // console.log('[Network] Data:', config.data ? JSON.stringify(config.data) : 'none');
      // console.log('[Network] Headers:', JSON.stringify(config.headers));
      // console.log('[Network] ====================================');
    // } catch (e) {
    //   // 日志失败不影响请求
    //   console.warn('[Network] Log error:', e);
    // }
    
    return config;
  },
  (error) => {
    Promise.reject(error);
  }
);

/* Response拦截器 */
service.interceptors.response.use(
  (response) => {
    // 添加响应日志
    // console.log('[Network] ========== Response Success ==========');
    // console.log('[Network] Status:', response.status);
    // console.log('[Network] StatusText:', response.statusText);
    // console.log('[Network] URL:', response.config.baseURL + response.config.url);
    // console.log('[Network] Data:', JSON.stringify(response.data));
    // console.log('[Network] =======================================');
    
    if (response.status === 200) {
      // 修改这里：增加对params中noLoading的判断
      if (!response.config.noLoading && (!response.config.params || !response.config.params.noLoading)) {
        endLoading();
      }
      return Promise.resolve(response.data);
    } else {
      Promise.reject(response.data);
    }
  },
  (error) => {
    // 关闭 loading（如果有的话）
    if (error.config && !error.config.noLoading && (!error.config.params || !error.config.params.noLoading)) {
      endLoading();
    }
    
    let message = "";
    if (error && error.response) {
      switch (error.response.status) {
        // case 401:
        //   setTimeout(() => {
        //     Toast("请重新登录~")
        //     sessionStorage.clear();//清除缓存
        //     $router.push({path: '/login'});//返回登录页
        //   }, 2200);
        //   break;
        // case 404:
        //   setTimeout(() => {
        //     Toast("请重新登录~")
        //     sessionStorage.clear();//清除缓存
        //     $router.push({path: '/login'});//返回登录页
        //   }, 2200);
        //   break;
        // case 400:
        //   setTimeout(() => {
        //     Toast("请重新登录~")
        //     sessionStorage.clear();//清除缓存
        //     $router.push({path: '/login'});//返回登录页
        //   }, 2200);
        //   break;
        // }
        // return;

        case 302:
          message = "接口重定向了！";
          break;
        case 400:
          message = "参数不正确！";
          break;
        case 401:
          message = "您未登录，或者登录已经超时，请先登录！";
          // 只在原生平台处理token过期自动刷新
          if (authService.isAutoLoginEnabled()) {
            handleTokenExpired().catch(err => {
              console.error('[Auth] Error handling token expiration:', err);
            });
          } else {
            // 浏览器环境直接跳转登录
            redirectToLogin().catch(err => {
              console.error('[Auth] Error redirecting to login:', err);
            });
          }
          break;
        case 403:
          message = "您没有权限操作！";
          break;
        case 404:
          message = `请求地址出错: ${error.response.config?.url || '未知地址'}`;
          break; // 在正确域名下
        case 408:
          message = "请求超时！";
          break;
        case 409:
          message = "系统已存在相同数据！";
          break;
        case 500:
          message = "系统开小差了，请稍后再试！";
          break;
        case 501:
          message = "服务未实现！";
          break;
        case 502:
          message = "网关错误！";
          break;
        case 503:
          message = "服务不可用！";
          break;
        case 504:
          message = "服务暂时无法访问，请稍后再试！";
          break;
        case 505:
          message = "HTTP版本不受支持！";
          break;
      }
    } else {
      // 处理没有 response 的错误（网络错误、CORS 错误等）
      if (error.message) {
        if (error.message.includes("timeout")) {
          message = "网络请求超时！";
        } else if (error.message.includes("Network") || error.message.includes("network")) {
          // 在原生 App 中，Network Error 可能是网络安全配置问题
          const isNative = window.Capacitor && window.Capacitor.isNativePlatform();
          if (isNative) {
            message = "网络连接失败，请检查：1)设备网络连接 2)Android网络安全配置 3)服务器是否可访问";
            console.error('[Network] Native Network Error - 可能的原因:');
            console.error('[Network] 1. 设备网络未连接');
            console.error('[Network] 2. Android 网络安全配置未生效（需要重新编译）');
            console.error('[Network] 3. 服务器无法访问');
            console.error('[Network] 4. SSL 证书问题');
            console.error('[Network] 请求 URL:', error.config?.baseURL + error.config?.url);
          } else {
            message = window.navigator.onLine ? "服务端异常！" : "您断网了！";
          }
        } else if (error.message.includes("CORS") || error.message.includes("cors")) {
          message = "跨域请求失败，请检查网络配置！";
        } else {
          message = error.message || "网络请求失败！";
        }
      } else {
        message = "网络请求失败！";
      }
    }
    
    // 只在有消息时显示 Toast
    if (message) {
      Toast({
        message: message,
      });
    }
    
    // 您未登录，或者登录已经超时，请先登录！
    if (error.response && error.response.status == 401) {
      // 调试：检查 sessionStorage 的状态
      console.log("=== 401 错误 - sessionStorage 状态检查 ===");
      console.log("accountTypeXpz 原始值:", sessionStorage.getItem("accountTypeXpz"));
      console.log("userInfoXpz 原始值:", sessionStorage.getItem("userInfoXpz"));
      console.log("sessionStorage 所有键:", Object.keys(sessionStorage));
      
      // 优先从 accountTypeXpz 获取，如果不存在则从 userInfoXpz 中获取
      let accountType = null;
      const accountTypeStr = sessionStorage.getItem("accountTypeXpz");
      console.log("accountTypeXpz 是否存在:", accountTypeStr !== null);
      
      if (accountTypeStr) {
        try {
          accountType = JSON.parse(accountTypeStr);
          console.log("从 accountTypeXpz 解析成功，accountType:", accountType);
        } catch (e) {
          console.error("解析 accountTypeXpz 失败:", e, "原始值:", accountTypeStr);
        }
      } else {
        console.log("accountTypeXpz 不存在，尝试从 userInfoXpz 获取");
      }
      
      // 如果 accountTypeXpz 不存在或解析失败，尝试从 userInfoXpz 中获取
      if (accountType === null || accountType === undefined) {
        const userInfoStr = sessionStorage.getItem("userInfoXpz");
        console.log("userInfoXpz 是否存在:", userInfoStr !== null);
        
        if (userInfoStr) {
          try {
            const userInfo = JSON.parse(userInfoStr);
            accountType = userInfo?.accountType;
            console.log("从 userInfoXpz 解析成功，accountType:", accountType);
          } catch (e) {
            console.error("解析 userInfoXpz 失败:", e, "原始值:", userInfoStr);
          }
        } else {
          console.log("userInfoXpz 也不存在");
        }
      }
      
      // 如果还是获取不到，尝试从 localStorage 中恢复
      if (accountType === null || accountType === undefined) {
        const localAccountTypeStr = localStorage.getItem("accountTypeXpz");
        console.log("localStorage accountTypeXpz 是否存在:", localAccountTypeStr !== null);
        if (localAccountTypeStr) {
          try {
            accountType = JSON.parse(localAccountTypeStr);
            console.log("从 localStorage accountTypeXpz 解析成功，accountType:", accountType);
          } catch (e) {
            console.error("解析 localStorage accountTypeXpz 失败:", e, "原始值:", localAccountTypeStr);
          }
        }
      }

      // 如果 localStorage 中没有 accountType，再尝试从 localStorage 的 userInfo 中获取
      if (accountType === null || accountType === undefined) {
        const localUserInfoStr = localStorage.getItem("userInfoXpz");
        console.log("localStorage userInfoXpz 是否存在:", localUserInfoStr !== null);
        if (localUserInfoStr) {
          try {
            const localUserInfo = JSON.parse(localUserInfoStr);
            accountType = localUserInfo?.accountType;
            console.log("从 localStorage userInfoXpz 解析成功，accountType:", accountType);
          } catch (e) {
            console.error("解析 localStorage userInfoXpz 失败:", e, "原始值:", localUserInfoStr);
          }
        }
      }

      // 如果仍然获取不到，使用默认值 1
      if (accountType === null || accountType === undefined) {
        console.warn("无法获取 accountType，使用默认值 1");
        accountType = 1;
      }
      
      console.log("=== 最终获取到的 accountType:", accountType, "===");
      // 调用函数
      redirectToLogin(accountType);
    }
    // $router.go(0);
    return Promise.reject(error);
  }
  // }
);

async function handleTokenExpired() {
  try {
    // 检查是否已经有刷新在进行
    if (authService.isRefreshingToken) {
      console.log('[Auth] Token refresh already in progress, waiting...');
      // 等待刷新完成
      await new Promise(resolve => {
        const checkRefresh = () => {
          if (!authService.isRefreshingToken) {
            resolve();
          } else {
            setTimeout(checkRefresh, 100);
          }
        };
        checkRefresh();
      });

      // 刷新完成后再次检查认证状态
      if (authService.isAuthenticated()) {
        console.log('[Auth] Token refresh completed successfully');
        return;
      }
    }

    // 尝试刷新token
    if (authService.getRefreshToken()) {
      try {
        console.log('[Auth] Attempting to refresh token...');
        await authService.refreshAccessToken();
        console.log('[Auth] Token refresh successful');
        return;
      } catch (refreshError) {
        console.error('[Auth] Token refresh failed:', refreshError);
      }
    }

    // 刷新失败，跳转到登录页面
    console.log('[Auth] Token refresh failed or no refresh token, redirecting to login');
    await redirectToLogin();
  } catch (error) {
    console.error('[Auth] Error handling token expiration:', error);
    await redirectToLogin();
  }
}

async function redirectToLogin(accountType) {
  try {
    // 清除认证状态
    await authService.logout();

    // 获取账号类型用于登录页面
    let finalAccountType = accountType;
    if (!finalAccountType) {
      finalAccountType = authService.getAccountType();
    }

    // 如果还是没有，默认使用1
    if (!finalAccountType) {
      finalAccountType = 1;
    }

    // 跳转到登录页面
    await $router.push({ path: "/verifyLogin", query: { type: finalAccountType } });
  } catch (error) {
    console.error('[Auth] Error redirecting to login:', error);
    // 兜底跳转
    $router.push({ path: "/verifyLogin", query: { type: 1 } });
  }
}

export default service;
